<template>
  <b-input-group>
    <b-form-input
      class="input-time__field"
      v-bind="$attrs"
      v-on="$listeners"
      type="time"
      :required="required"
      v-model="valueProxy"
      @blur.native="$emit('blur-native-proxy', $event)"
    >
    </b-form-input>
    <b-input-group-append>
      <b-button
        class="clock-button"
        size="sm"
        variant="outline-secondary"
        v-bind="$attrs"
        v-on:click="onClickTimeNow"
      >
        <i
          aria-hidden="true"
          class="far fa-clock"
        />
      </b-button>
    </b-input-group-append>
  </b-input-group>
</template>

<script>

import {
  formatter as dateTimeFormatter,
  getNow,
} from '@/services/dateTime/datetimeService';
import {
  formats,
} from '@/constants/localizer';

export default {
  props: {
    value: {
      type: String,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    withSeconds: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    valueProxy: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    mask() {
      return this.withSeconds
        ? formats.ISO_TIME
        : formats.ISO_TIME_WITHOUT_SECONDS;
    },
  },
  methods: {
    onClickTimeNow() {
      this.valueProxy = dateTimeFormatter(getNow(), this.mask);
      this.$emit('input-time-now-click');
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"

  .input-time
    &__field::-webkit-calendar-picker-indicator
      display: none
      background: none
  .clock-button
    border-color: $color-form-elements-border
    font-size: 1rem
    padding: 0.375rem 0.75rem
    i
      color: --color-gray
  .clock-button:not(:hover)
    background-color: var(--color-background-dark)
</style>
